import React from 'react';
import {Col, Row, Card} from 'react-bootstrap';
import * as ModelsWorkflowInbox from '../../models/workflow/WorkflowInbox';

var imgItem = require('../../assets/image/report-item.png');
var imgTax = require('../../assets/image/report-tax.png');

type Align = 'left' | 'center' | 'right';

export type ReportCardProps = {
    listItem: ModelsWorkflowInbox.CardItem;
};

export const ReportCard = (props: ReportCardProps) => {
    const { listItem } = props;

    function convertToMultiDimensional<T>(
      oneDArray: T[],
      chunkSize: number
    ): T[][] {
      const multiDArray: T[][] = [];
      for (let i = 0; i < oneDArray.length; i += chunkSize) {
        multiDArray.push(oneDArray.slice(i, i + chunkSize));
      }
      return multiDArray;
    }

    return (
        <Row className="mt-3">
                <Col>
                    <Card style={{
                            borderRadius: '15px',
                            background: 'none',
                            border: 'none',
                        }}
                    >
                        <Card.Header
                            style={{
                                backgroundColor: '#FAEDC4',
                                border: 'none',
                                borderTopLeftRadius: '15px',
                                borderTopRightRadius: '15px'
                            }}
                        >
                            <Row>
                                    <img
                                        src={imgItem}
                                        style={{
                                            marginLeft: '16px',
                                            marginRight: '16px',
                                            marginTop: '4px',
                                            marginBottom: '4px',
                                            width: '20px',
                                            height: '20px'
                                        }}
                                        alt="file"
                                    />
                                    <p style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <b>{listItem.title.label}</b>
                                    </p>
                            </Row>
                        </Card.Header>
                        <Card.Body
                            style={{
                                border: '1px solid #D9D9D9',
                                borderBottomLeftRadius: '15px',
                                borderBottomRightRadius: '15px',
                                borderTop: 'none'
                            }}
                        >
                        <div className="-mt-3">
                        {listItem.ListSubCard.map((cardItem, idx) => (
                            <Row key={idx} className="mt-3">
                                    <Col>
                                        <Card style={{
                                                borderRadius: '15px',
                                                background: 'none',
                                                border: 'none',
                                            }}
                                        >
                                            <Card.Header
                                                style={{
                                                    border: '1px solid #D9D9D9',
                                                    background: 'none',
                                                    borderTopLeftRadius: '15px',
                                                    borderTopRightRadius: '15px',
                                                    borderBottom: 'none'
                                                }}
                                            >
                                                <Row>
                                                        <p style={{
                                                            marginLeft: '16px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}>
                                                            <b>{cardItem.title.label + ' - ' + cardItem.title.value}</b>
                                                        </p>
                                                </Row>
                                            </Card.Header>
                                            <Card.Body
                                                style={{
                                                    border: '1px solid #D9D9D9',
                                                    borderBottomLeftRadius: '15px',
                                                    borderBottomRightRadius: '15px',
                                                    borderTop: 'none'
                                                }}
                                            >     
                                                {convertToMultiDimensional(cardItem.ListLable, 2).map((row, rindx) => 
                                                        <Row key={rindx}
                                                            style={{
                                                                marginLeft: '16px'
                                                            }}
                                                        >
                                                        {row.map((data,index) =>
                                                            <Col key={index} lg={6}>
                                                                <table
                                                                    className="text-left"
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <tbody>
                                                                        <tr key={idx}>
                                                                            <td style={{ width: '40%' }}>
                                                                                <label>
                                                                                    <b>{data.label + ' :'}</b>
                                                                                </label>
                                                                            </td>
                                                                            <td style={{ width: '60%' }}>{data.value}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                        </Col>
                                                        )}
                                                    </Row>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            ))}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            );
};